import * as React from 'react';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}

export default AccordionContext;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Accordion/AccordionContext.js
// module id = 802
// module chunks = 2